module.exports = __webpack_public_path__ + "img/V-63-ER-1500-BB.bb55edf5.png";